import produce from "immer";
import {
  FETCH_SHIFT,
  FETCH_SHIFT_SUCCESS,
  FETCH_SHIFT_FAILURE,
  //
  GET_VIEW_DATA,
  GET_VIEW_DATA_SUCCESS,
  GET_VIEW_DATA_FAILURE,
  //
  ADD_SHIFT,
  ADD_SHIFT_SUCCESS,
  ADD_SHIFT_FAILURE,
  //
  EDIT_SHIFT,
  EDIT_SHIFT_SUCCESS,
  EDIT_SHIFT_FAILURE,
  //
  DELETE_SHIFT,
  DELETE_SHIFT_SUCCESS,
  DELETE_SHIFT_FAILURE,
  //
  GET_HISTORY,
  GET_HISTORY_SUCCESS,
  GET_HISTORY_FAILURE,
  TOGGLE_HISTORY,
  //
  GET_CLOCK_HISTORY,
  GET_CLOCK_HISTORY_SUCCESS,
  GET_CLOCK_HISTORY_FAILURE,
  TOGGLE_CLOCK_HISTORY,
} from "./constants";

export const initialState = {
  isFetchingShift: false,
  employeeList: [],
  // Add / Edit
  isSubmitting: false,
  isAddingShift: false,
  // View
  isFetching: false,
  currentShift: {},
  // Delete
  isDeleting: false,
  defaultPerms: [],
  currentPerms: [],
  //
  isSearchingShift: false,
  searchEmpList: [],
  //
  isSavingDocs: false,
  isUpdatingSchedule: false,
  //
  isFetchingHistory: false,
  shiftHistory: [],
  //
  historyModal: { open: false },
  clockHistoryModal: { open: false },
  //
  isFetchingClockHistory: false,
  clockHistory: [],
};

const ShiftReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      // List
      case FETCH_SHIFT:
        draft.isFetchingShift = true;
        draft.currentShift = {};
        break;
      case FETCH_SHIFT_SUCCESS:
        draft.isFetchingShift = false;
        draft.employeeList = action.payload;
        break;
      case FETCH_SHIFT_FAILURE:
        draft.isFetchingShift = false;
        break;
      // View
      case GET_VIEW_DATA:
        draft.isFetching = true;
        draft.currentShift = {};
        break;
      case GET_VIEW_DATA_SUCCESS:
        draft.isFetching = false;
        draft.currentShift = action.payload;
        break;
      case GET_VIEW_DATA_FAILURE:
        draft.isFetching = false;
        break;
      // Add
      case ADD_SHIFT:
        draft.isAddingShift = true;
        break;
      case ADD_SHIFT_SUCCESS:
        draft.isAddingShift = false;
        break;
      case ADD_SHIFT_FAILURE:
        draft.isAddingShift = false;
        break;
      // Edit
      case EDIT_SHIFT:
        draft.isSubmitting = true;
        break;
      case EDIT_SHIFT_SUCCESS:
        draft.isSubmitting = false;
        break;
      case EDIT_SHIFT_FAILURE:
        draft.isSubmitting = false;
        break;
      // Delete
      case DELETE_SHIFT:
        draft.isDeleting = true;
        break;
      case DELETE_SHIFT_SUCCESS:
        draft.isDeleting = false;
        break;
      case DELETE_SHIFT_FAILURE:
        draft.isDeleting = false;
        break;
      //
      case GET_HISTORY:
        draft.isFetchingHistory = true;
        draft.shiftHistory = [];
        break;
      case GET_HISTORY_SUCCESS:
        draft.isFetchingHistory = false;
        draft.shiftHistory = action.payload;
        break;
      case GET_HISTORY_FAILURE:
        draft.isFetchingHistory = false;
        draft.shiftHistory = [];
        break;
      case TOGGLE_HISTORY:
        draft.historyModal = action.payload;
        break;

      case GET_CLOCK_HISTORY:
        draft.isFetchingClockHistory = true;
        draft.clockHistory = [];
        break;
      case GET_CLOCK_HISTORY_SUCCESS:
        draft.isFetchingClockHistory = false;
        draft.clockHistory = action.payload;
        break;
      case GET_CLOCK_HISTORY_FAILURE:
        draft.isFetchingClockHistory = false;
        draft.clockHistory = [];
        break;
      case TOGGLE_CLOCK_HISTORY:
        draft.clockHistoryModal = action.payload;
        break;

      default:
        return state;
    }
  });

export default ShiftReducer;
